import { FormulaInput } from 'browser/components/atomic-elements/atoms/input/formula-input'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
const FormulaField = LabelFieldFactory({ InputComponent: FormulaInput })
export {FormulaField}
